<template>
    <router-link :to="{ name: 'installation', params: { id: $route.params.id, idInst: installation.id } }"
        class="block bg-[#EDF2F7] relative" :class="gotFluide ? '' : 'opacity-95'">
        <div class="px-3 py-3">
            <!-- Nom + Marque/Modèle -->
            <div class="flex items-start justify-between gap-3">
                <div>
                    <p class="text-lg leading-tight text-bleu-moyen">
                        <strong class="font-bold">{{ installation.nom }}</strong>
                    </p>
                    <p v-if="installation.marque && installation.modele" class="text-sm text-gris mt-0.5">
                        <span class="marque-modele">
                            {{ installation.marque }} - <b>{{ installation.modele }}</b>
                        </span>
                    </p>
                </div>

                <!-- “Barre” icône à droite si tu l’utilises -->
                <div ref="icon-barre" class="shrink-0"></div>
            </div>

            <!-- Infos (pills) -->
            <div class="mt-3 flex flex-wrap items-center gap-2">
                <!-- Fluide (si présent) -->
                <div v-if="gotFluide"
                    class="flex items-center gap-1 px-3 py-2 rounded-r-full bg-secondary text-white text-sm font-medium -ml-4 pl-5">
                    <i class="inline-block h-5 w-5 mask mask-snow bg-white"></i>
                    {{ installation.fluide.nom }}
                </div>

                <!-- Charge totale (si fluide) -->
                <div v-if="gotFluide"
                    class="flex items-center gap-1 rounded-full bg-bleu-moyen text-white text-sm font-medium px-3 py-2">
                    <i class="inline-block h-5 w-5 mask mask-weight bg-white"></i>
                    {{ installation.charge | number('0,00') }} KG
                </div>

                <!-- OTAG (si présent) -->
                <div v-if="installation.i_tag !== null"
                    class="flex items-center gap-1 rounded-full bg-otag-install text-white text-sm font-medium px-3 py-2">
                    <i class="inline-block h-5 w-5 mask mask-otag-install bg-white"></i>
                    {{ installation.i_tag }}
                </div>
            </div>
        </div>

        <!-- Séparateur blanc comme sur tes autres listes -->
        <div class="h-4 bg-white"></div>
    </router-link>
</template>

<script>
import Installation from "../../js/models/Installation";

export default {
    data() {
        return {

        }
    },
    props: {
        installation: {

        }
    },
    computed: {
        gotFluide() {
            return (!_.isEmpty(this.installation.fluide));
        }
    },
    methods: {
        generateAlert(messages = []) {

            let html = '';
            messages.forEach(function (message) {
                html += `<div class="tooltip-container"> <i class="fas fa-exclamation-triangle alert-icon thisPreventDefault" style="color: ${message.color}"></i> <div class="tooltip">${message.tooltip}</div></div>`;
            })
            this.$refs["icon-barre"].innerHTML = html;
        }
    },
    mounted() {
        let vue = this;
        Installation.getAlertes(this.installation).then(function (alertes) {
            let messages = [];
            for (const key in alertes) {

                if (key === 'periodique') {
                    messages.push({
                        tooltip: "Contrôle périodique <br>" + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire'),
                        color: alertes[key] === "alert" ? 'red' : 'orange',
                        message: 'Contrôle <br> périodique<br> ' + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire')
                    })
                }

                if (key === "desp") {
                    messages.push({
                        tooltip: "Contrôle DESP <br>" + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire'),
                        color: alertes[key] === "alert" ? 'red' : 'orange',
                        message: 'Contrôle <br> DESP<br> ' + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire')
                    })
                }

                if (key === 'maintenance') {
                    messages.push({
                        tooltip: "Maintenance préventive <br>" + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire'),
                        color: alertes[key] === "alert" ? 'red' : 'orange',
                        message: 'Maintenance <br> Préventive<br> ' + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire')
                    })
                }

                if (key === 'attestation') {
                    messages.push({
                        tooltip: "Attestation d\'entretien",
                        color: alertes[key] === "alert" ? 'red' : 'orange',
                        message: 'Attestation<br> d\'entretien ' + (alertes[key] === "alert" ? 'Dépassé' : 'A Faire')
                    })
                }

            }

            vue.generateAlert(messages);

        }).then(function () {
            let tooltipContainer = document.querySelectorAll('.tooltip-container');
            tooltipContainer.forEach(function (tooltip) {
                tooltip.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    let tooltip = this.querySelector('.tooltip');
                    tooltip.classList.toggle('show');
                })
            })

        })

    },
}
</script>

<style>
.list-installations .install {
    position: relative;
    min-height: 95px;
    margin-bottom: 5px;
    background-color: #eeeeee;
    padding: 8px 10px;
    width: 100%;
    display: block;
}

.list-installations .install:after {
    content: '\e909';
    font-family: 'fi360' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    font-size: 3.3rem;
    position: absolute;
    right: 10px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    color: #5698d2;
}

.refrigerant-install {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    background-color: #393c51;
    position: relative;
    color: #fff;
    font-weight: 700;
    font-size: 1.8rem;
    padding: 0 15px 0 5px;
    height: 35px;
}

.otagInstall {
    background-color: #EA5E0B;
    padding: 7px 5px;
    color: white;
    font-weight: bold;
    margin-left: 5px;
    height: 35px;
    border-radius: 5px;
    max-width: 100px;
}

.list-installations .install.nofluide {
    min-height: 70px;
}

.list-installations .install.off {
    display: none;
}

.list-installations .install p.identification {
    color: #666;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 10px;
}

.list-installations .install p.identification strong {
    color: #000;
    margin-bottom: 5px;
    font-size: 2rem;
    font-weight: 400;
}

.list-installations .install p.identification b {
    font-weight: 700;
}

.list-installations .install .actions a.btn {
    /*display: inline-flex;*/
    float: right;
}

.list-installations .install .actions a.btn.toggle-actif {
    border-radius: 5px;
    background-color: #cccccc;
    width: 50px;
    padding-left: 7px;
    margin-bottom: 5px;
}

.list-installations .install .actions a.btn.toggle-actif i {
    color: #999;
    font-size: 2.7rem;
}

.list-installations .install .infos-sup {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -ms-align-items: center;
    align-items: center;


}

.list-installations .install .charge-totale {
    margin-left: 15px;
    font-size: 1.4rem;
}

.list-installations .install .charge-totale b {
    display: block;
    font-size: 1.6rem;
}

.icon-barre {
    display: flex;
}

.alert-icon {
    font-size: 35px;
}

.tooltip-container {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    padding: 5px;
}

.tooltip {
    display: none;
    position: absolute;
    background-color: #333;
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    z-index: 1;
    white-space: nowrap;
    top: 0;
    left: -1px;
    text-align: center;
}

.tooltip-container:hover .tooltip {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// InstallationItem.vue?8973ef88